<script lang="ts">
    import { DiceRoll } from "../../../lib/dice_rolls";
    import CalculatorNumberInput from "../CalculatorNumberInput.svelte";

    let amount: number | null = null;
    let sides: number | null = null;
    let modifier: number = 0;

    export let diceRoll: DiceRoll | null = null;

    $: if (amount !== null && sides !== null && modifier !== null) {
        diceRoll = new DiceRoll(amount, sides, modifier);
    }
</script>

<div class="dice-roll-input">
    <CalculatorNumberInput bind:number={amount} placeholder="" />
    <p class="font-size-1-5-rem">d</p>
    <CalculatorNumberInput bind:number={sides} placeholder="" />
    <p class="font-size-1-5-rem">+</p>
    <CalculatorNumberInput bind:number={modifier} placeholder="" />
</div>
